<section class="admin-page ct-page ai-mkt">
  <app-ai-marketing-feature-header
    titleKey="aiMarketing.nav.organic"
    subtitleKey="aiMarketing.organic.subtitle"
  />

  <div class="ct-card">
    @if (loading()) {
      <p>{{ 'common.loading' | t }}</p>
    } @else if (loadError()) {
      <p class="muted">{{ 'aiMarketing.loadError' | t }}</p>
      <button type="button" class="ct-btn ct-btn-sm ct-btn-navy" (click)="reload()">
        {{ 'common.retry' | t }}
      </button>
    } @else if (!posts().length) {
      <p class="muted">{{ 'aiMarketing.organic.empty' | t }}</p>
    } @else {
      <div class="creative-grid">
        @for (p of posts(); track p.id) {
          <article class="creative-card">
            <div class="creative-card-media">
              @if (isVideo(p) && assetUrl(p)) {
                <video [src]="assetUrl(p)!" controls playsinline preload="none"></video>
              } @else if (assetUrl(p)) {
                <img [src]="assetUrl(p)!" [alt]="p.caption || ''" />
              } @else {
                <p class="muted">—</p>
              }
            </div>
            <div class="creative-card-meta">
              <div class="published-platforms">
                <span
                  class="platform-chip"
                  [class.platform-facebook]="p.platform === 'Facebook'"
                  [class.platform-instagram]="p.platform === 'Instagram'"
                  [attr.title]="platformKey(p.platform) | t"
                >
                  @if (p.platform === 'Facebook') {
                    <span class="material-symbols-outlined" aria-hidden="true">public</span>
                  } @else if (p.platform === 'Instagram') {
                    <span class="material-symbols-outlined" aria-hidden="true">photo_camera</span>
                  }
                  <span class="platform-chip-label">{{ platformKey(p.platform) | t }}</span>
                </span>
              </div>
              <p>
                <span
                  class="ct-badge"
                  [class.ct-badge-success]="p.status === 'Published'"
                  [class.ct-badge-muted]="p.status === 'Draft' || p.status === 'Approved'"
                  [class.ct-badge-danger]="p.status === 'Failed'"
                >
                  {{ statusKey(p.status) | t }}
                </span>
              </p>
              <p class="muted">{{ displayDate(p) | date: 'medium' }}</p>
              @if (p.caption) {
                <p class="muted creative-card-title">{{ p.caption }}</p>
              }
            </div>
            <div class="creative-card-footer">
              @if (p.externalUrl) {
                <a [href]="p.externalUrl" target="_blank" rel="noopener" class="ct-btn ct-btn-navy ct-btn-sm">
                  {{ 'aiMarketing.organic.viewPost' | t }}
                </a>
              } @else if (p.errorMessage) {
                <p class="muted organic-error">{{ p.errorMessage }}</p>
              }
            </div>
          </article>
        }
      </div>
    }
  </div>
</section>
